import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import sv from "./locales/sv.json";
import en from "./locales/en.json";
import fi from "./locales/fi.json";
import nb from "./locales/nb.json";
import de from "./locales/de.json";
import nl from "./locales/nl.json";

export const LANGUAGES = [
  { code: "sv", label: "Svenska" },
  { code: "en", label: "English" },
  { code: "fi", label: "Suomi" },
  { code: "nb", label: "Norsk" },
  { code: "de", label: "Deutsch" },
  { code: "nl", label: "Nederlands" },
];

export const LOCALES = { sv: "sv-SE", en: "en-GB", fi: "fi-FI", nb: "nb-NO", de: "de-DE", nl: "nl-NL" };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      sv: { translation: sv },
      en: { translation: en },
      fi: { translation: fi },
      nb: { translation: nb },
      de: { translation: de },
      nl: { translation: nl },
    },
    fallbackLng: "sv",
    supportedLngs: LANGUAGES.map((l) => l.code),
    nonExplicitSupportedLngs: true,
    detection: { order: ["localStorage"], lookupLocalStorage: "fm_lang", caches: ["localStorage"] },
    interpolation: { escapeValue: false },
  });

export const currentLocale = () => LOCALES[i18n.language?.slice(0, 2)] || "sv-SE";

export default i18n;
